import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Big Data">
                            <h2>Seamless Process To Improve Your Results Through Our Big Data And Analytics
                                Solutions</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>We believe in our process to deliver on our process of operational excellence and serve you
                            to the best of our capacity. Our big data & analytics services help you form data-driven and
                            intelligent solutions that comprehensively cover data management, visualization, and
                            advanced analytics to deliver superior results.</p>
                        <p>
                            TekRevol helps its clients to unearth critical knowledge through their data. Leveraging
                            emerging technologies, including artificial intelligence and machine learning, we help you
                            extract the information you have been missing out on. Put your data to the proper use, and
                            unlock the door to new possibilities.
                        </p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;